import React from 'react';
import { Link } from 'react-router';
import Picture from '../Picture.jsx';
import VButton from '../VButton.jsx';
import { appContext } from '../../util/decorators';
import viasport from '../../../assets/logos/viasat-sport.jpg';
import viaplay from '../../../assets/logos/viaplay.png';

@appContext
export default class FollowMail extends React.PureComponent {
  render() {
    const t = this.context.app.t;

    return (
      <div className="follow">
        <div className="follow-head">
          <div className="follow-title">
            <span className="icon-container mail">
              <i className="icon-email"></i>
            </span>
            {t('FollowMail.social_blurb')}
          </div>
        </div>

        <h2>{t('FollowMail.heading')}</h2>

        <div className="inner">
          <form>
            <fieldset className="options">
              <ul>
                <li>
                  <label htmlFor="viasatsport">
                    <div className="options-logo">
                      <Picture src={viasport} alt="Viasport" />
                    </div>
                    <div className="option-text">
                      <span className="option-title">{t('FollowMail.viasport_option_title')}</span>
                      <p className="option-description">{t('FollowMail.viasport_option_description')}</p>
                    </div>
                  </label>

                  <input name="viasatsport" id="viasatsport" value="1" type="checkbox" className="checkbox" checked />
                </li>
                <li>
                  <label htmlFor="viaplay">
                    <div className="options-logo">
                      <Picture src={viaplay} alt="Viaplay" />
                    </div>
                    <div className="option-text">
                      <span className="option-title">{t('FollowMail.viaplay_option_title')}</span>
                      <p className="option-description">{t('FollowMail.viaplay_option_title')}</p>
                    </div>
                  </label>
                  <input name="viaplay" id="viaplay" value="1" type="checkbox" className="checkbox" />
                </li>
              </ul>
            </fieldset>

            <fieldset className="subscribe">
              <label htmlFor="email" className="structural">{t('FollowMail.email_label')}</label>
              <input className="input-field" id="email" name="email" type="email" placeholder={t('FollowMail.email_label')} required />
              <VButton type="primary">{t('FollowMail.sign_up')}</VButton>
            </fieldset>
          </form>

          <Link to="#" className="examples">{t('FollowMail.see_examples')}</Link>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Page/FollowEmail.jsx